import React, { useEffect, useState } from 'react';

export const InputDemo = (props) => {
    const [value,setValue] = useState('');

    const [products,setProducts] = useState(null);

    useEffect(() => {
        setValue(props.value.yil);
        setProducts(null);
        if(props.data!=null){
            setProducts(props.data.yonetim);
            
        }
        
        
    }, [value]);



    return (
        <div className="grid">
            <div className="col-12 md:col-16">
                <div className='card'>
                    <h5 style={{marginLeft:400}}>Toplu Yapı Denetim Kurulu</h5>

                    { value=="" || value=="Tümü"   ?
                        <div >
                            
                        </div>
                        :
                        <div className="mb-13" style={{marginLeft:160}}>
                            {/*products != null ?<img src={require('.'+products[1].dosya)} className="product-image" />:<div></div>*/}
                            {products != null ?<img src={"https://www.atakent2.org.tr"+props.data.yonetim[1].dosya} className="product-image" />:<div></div>}
                        </div>
                    }
                </div>
                
                        
            </div>
        </div >
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(InputDemo, comparisonFn);